module.exports = __webpack_public_path__ + "static/img/banner.16d5394.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/onlinePreview/banner.png
// module id = 6tPr
// module chunks = 2